/* Import components */

import React, {useEffect, useState, useRef} from 'react';
import {Field} from 'formik';

import {useHistory, useParams} from 'react-router';
import {useSelector} from 'react-redux';
import {Form, DataTable} from '../components';
import Select from 'react-select';

import {languages, countries} from '../config';

import {Chatbot, User} from '../states/actions';
import {axios} from '../libs';
import {buildChatbotPreviewUrl} from '../libs/paymentPortal';

import {find as _find, filter as _filter} from 'lodash';

import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from 'ckeditor5-custom-build';

import {SortableContainer, SortableElement, sortableHandle } from 'react-sortable-hoc';
import {arrayMoveImmutable} from 'array-move';
import {InputComponent} from '../components/ChatbotBuilder/Components'
import logger from '../utils/logger';

/* Format date */

function formatDateDMY(date) {
	if (!date) return '';
	const d = new Date(date);
	const day = d.getDate().toString().padStart(2, '0');
	const month = (d.getMonth() + 1).toString().padStart(2, '0');
	const year = d.getFullYear();
	return `${day}.${month}.${year}`;
}

/* Sortable item */

const DragHandle   = sortableHandle(() => <span> : : </span>);

const SortableItem = SortableElement(({ value, handleInputChange, remove }) => (
	<div>
		<DragHandle />
		<input
		type         = "text"
		defaultValue = {value}
		onBlur       = {handleInputChange}
		/>
		<button onClick={remove}>Remove</button>
	</div>
	)
);

const SortableList = SortableContainer(({ items, handleInputChange, remove }) => (
	<ul>
		{items.map((item, index) => (
			<SortableItem
				key               = {item.id}
				index             = {index}
				value             = {item.value}
				handleInputChange = {(e) => handleInputChange(e, index)}
				remove            = {(e) => remove(item.id)}
			/>
		))}
	</ul>
));

/* Export chatbots */

export const Chatbots = () => {
	const [refetch, setrefetch] = useState(false);
	const {push}                = useHistory();
	const {chatbotId}           = useParams();
	const {blocks, ...data}     = useSelector(Chatbot.get());
	const {_id}                 = useSelector(User.get());
	
	/* Modal handlers */
	
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [copydata, setCopyData]       = useState();
	
	const openModal  = () => { setIsModalOpen(true); };
	const closeModal = () => { setIsModalOpen(false); };
	
	useEffect(() => {
		if (chatbotId) {
		(async () => {
			const {blocks, ...data} = await Chatbot.fetch(chatbotId);
			Chatbot.set(data);
		})();
		} else {
			Chatbot.clear();
		}
	}, [chatbotId]);

	const onSuccess = ({chatbot}) => {
		setrefetch(false);
		Chatbot.set(chatbot);
		if (chatbotId) {
			push('/chatbots');
			setrefetch(true);
		} else {
			push(`/chatbot-builder/${chatbot._id}`);
		}
	};
	
	/* To copy blocks all the ids need to be regenerated and also the logical connections between blocks */
	/* const updateIDsAndReferences = async (data, newbotid) =>  {
	logger.log("Nendest andmetest tahan teha koopia: " + data)
	let idMap = {};
	// Create mapping of old IDs to new IDs
	for (let key in data) {
		// getting new unique ids
		idMap[key] = await getBlockId();
	}
	// Replace object keys and IDs with new IDs
	let updatedData = {};
	for (let key in data) {
		let newObjKey = idMap[key];
		updatedData[newObjKey] = { ...data[key], id: newObjKey};
		// If the data object has an _id field, update that as well
		if (updatedData[newObjKey].data && updatedData[newObjKey].data._id) {
			updatedData[newObjKey].data._id = newObjKey;
		}
		if (updatedData[newObjKey].data && updatedData[newObjKey].data.chatbotId) {
			updatedData[newObjKey].data.chatbotId = newbotid;
		}
	}
	// Update references
	for (let key in updatedData) {
		let obj = updatedData[key];
		if (obj.data) {
			if (obj.data.next) obj.data.next = idMap[obj.data.next] || obj.data.next;
			if (obj.data.nextOnTrue) obj.data.nextOnTrue = idMap[obj.data.nextOnTrue] || obj.data.nextOnTrue;
			if (obj.data.nextOnFalse) obj.data.nextOnFalse = idMap[obj.data.nextOnFalse] || obj.data.nextOnFalse;
			if (obj.data.nextOnNoEmail) obj.data.nextOnNoEmail = idMap[obj.data.nextOnNoEmail] || obj.data.nextOnNoEmail;
			if (obj.data.nextOnNoClient) obj.data.nextOnNoClient = idMap[obj.data.nextOnNoClient] || obj.data.nextOnNoClient;
			if (obj.data.next_secondary) obj.data.next_secondary = idMap[obj.data.next_secondary] || obj.data.next_secondary;
			if (obj.data.options) {
				for (let optionKey in obj.data.options) {
					if (obj.data.options[optionKey].next) {
						obj.data.options[optionKey].next = idMap[obj.data.options[optionKey].next] || obj.data.options[optionKey].next;
					}
				}
			}
			if (obj.data.reviews) {
				for (let reviewKey in obj.data.reviews) {
					if (obj.data.reviews[reviewKey].element && obj.data.reviews[reviewKey].element.id) {
						obj.data.reviews[reviewKey].element.id = idMap[obj.data.reviews[reviewKey].element.id] || obj.data.reviews[reviewKey].element.id;
						obj.data.reviews[reviewKey].element.value = idMap[obj.data.reviews[reviewKey].element.value] || obj.data.reviews[reviewKey].element.value;
						obj.data.reviews[reviewKey].element.content = idMap[obj.data.reviews[reviewKey].element.content] || obj.data.reviews[reviewKey].element.content;
					}
				}
			}
		}
		if (obj.source) obj.source = idMap[obj.source] || obj.source;
		if (obj.target) obj.target = idMap[obj.target] || obj.target;
	}
	return updatedData;
	} */
	const getBlockId = async () => {
		let {id} = await axios.get('/block/id');
		return id; //error checking
	};
	
	/* To copy blocks all the ids need to be regenerated and also the logical connections between blocks */
	
	const updateIDsAndReferences = async (data, newbotid) => {
		logger.log("Nendest andmetest tahan teha koopia: " + JSON.stringify(data));
		let idMap = {};
		
		/* Create mapping of old IDs to new IDs */
		
		for (let key in data) {
			idMap[key] = await getBlockId(); // Getting new unique ids
		}
		
		/* Replace object keys and IDs with new IDs */
		
		let updatedData = {};
		for (let key in data) {
			let newObjKey = idMap[key];
			updatedData[newObjKey] = { ...data[key], id: newObjKey };

			// If the data object has an _id field, update that as well

			if (updatedData[newObjKey].data && updatedData[newObjKey].data._id) {
				updatedData[newObjKey].data._id = newObjKey;
			}
			if (updatedData[newObjKey].data && updatedData[newObjKey].data.chatbotId) {
				updatedData[newObjKey].data.chatbotId = newbotid;
			}
		}
		
		/* Recursive function to update 'next' and '_id' fields */
		
		const updateNextFields = (obj) => {
			if (typeof obj !== 'object' || obj === null) return;
			for (let key in obj) {
				if (!obj.hasOwnProperty(key)) continue;
				if ((key === 'next' || key === '_id') && typeof obj[key] === 'string') {
					obj[key] = idMap[obj[key]] || obj[key];
				} else if (typeof obj[key] === 'object') {
					updateNextFields(obj[key]);
				}
			}
		};
		
		/* Update references */
		
		for (let key in updatedData) {
			let obj = updatedData[key];
			if (obj.data) { updateNextFields(obj.data); }
			if (obj.source) obj.source = idMap[obj.source] || obj.source;
			if (obj.target) obj.target = idMap[obj.target] || obj.target;
		}
		return updatedData;
	};
	
	/* Create copies into database */
	
	const createBlocksCopies = async (data, newbotid) => {
	
		/* Using let handle as obj, because handle will be the object name in meta data of handle obj, otherwise handle as object name is not needed */
		
		for (let key in data) {
			let handle = data[key];
			Chatbot.setBlock(handle);
			if(handle.data.type === "handle") {
				const _id = handle.id
				const response = Chatbot.setBlockData(
					_id,
					{
					_id: handle.id,
					type: 'handle',
					chatbotId: newbotid,
					meta: {handle},
					},
					true,
				);
				logger.log(response)
			} else {
				const response = await Chatbot.setBlockData(handle.id, {}, true);
				logger.log(response)
			}
		}
	}
	
	/* Not needed atm */
	
	function deepClone(obj) {
		return JSON.parse(JSON.stringify(obj));
	}
	
	/* Table actions */
	
	const onDelete = ({_id, name}) => {
		setrefetch(false);
		window.nConfirm({
			icon: 'fa-question-circle',
			title: 'Delete app?',
			text: `<span>${name}</span>`,
			onYes: () => {deleteChatbot(_id)},
			onNo:  () => {},
		});
	};
	
	const onCopy = ({_id}) => {
		setrefetch(false);
		window.nConfirm({
			icon: 'fa-question-circle',
			title: 'Confirm!',
			text: 'Are you sure you want to copy this chatbot?',
			onYes: () => {copyChatbot(_id)},
		});
	};
	
	const deleteChatbot = async (id) => {
		await axios.delete(`/chatbot/${id}`);
		setrefetch(true);
	};
	
	const copyChatbot = async (id) => {
		
		/* Need to copy chatbot first and get its id */
		
		const newbot = await axios.post(`/chatbot/cloneBot`, {chatbotId: id});
		const newbotid = newbot.message;
		setrefetch(true);
		
		/* Copy blocks into new array with new ids + add new chatbotId */
		
		const {blocks} = await Chatbot.fetch(id);
		logger.log("Current blocks:" , blocks);
		
		// const newobject = deepClone(blocks);
		
		const newdata = await updateIDsAndReferences(blocks, newbotid)
		logger.log(newdata)
		
		/* Add these new blocks into system */
		
		createBlocksCopies(newdata, newbotid)
		
	};
	
	const onData= (data) => {
		logger.log(chatbotId)
		if(chatbotId === undefined) {
			push(`chatbot/conversation/${data._id}`)
		} else {
			push(`${data._id}`)
		} 
	};
	
	const onPreview= (data) => {
		window.open(buildChatbotPreviewUrl(data._id), '_blank');
	};
	
	const onEdit = (data) => {
		logger.log(chatbotId)
		if(chatbotId === undefined) {
			push(`chatbots/${data._id}`)
		} else {
			push(`${data._id}`)
		} 
	};
	
	/* Submission columns
	const submissionsColumns = [
		{
			dataField: '_id',
			text: 'ID',
			classes: 'cell-id',
			headerClasses: 'cell-id',
			formatter: (cell, row, rowIndex, formatExtraData) => {
				return rowIndex + 1;
			},
		},
		{
			dataField: 'chatbot.name',
			text: 'Name',
			classes: 'cell-name',
			headerClasses: 'cell-name',
		},  
		{
			dataField: 'chatbot.img',
			text: 'Image',
			classes: 'cell-image',
			headerClasses: 'cell-image',
		},
		{
			dataField: 'chatbot.description',
			text: 'Description',
			classes: 'cell-description',
			headerClasses: 'cell-description',
		},
		{
			dataField: 'user',
			text: 'Owner',
			classes: 'cell-owner',
			headerClasses: 'cell-owner',
			formatter: ({firstName, lastName}) => {
				return `${firstName} ${lastName}`;
			},
		},
		{
			dataField: 'updatedAt',
			text: 'Modified',
			classes: 'cell-modified',
			headerClasses: 'cell-modified',
			formatter: d => formatDateDMY(d),
		},
		{
			dataField: 'createdAt',
			text: 'Created',
			classes: 'cell-created',
			headerClasses: 'cell-created',
			formatter: d => formatDateDMY(d),
		},
	]; */
	
	/* Table columns */
	
	const tableColumns = [
		{
			dataField: 'name',
			text: 'Name',
			classes: 'cell-name',
			headerClasses: 'cell-name',
		},
		{
			dataField: 'user',
			text: 'Owner',
			classes: 'cell-owner',
			headerClasses: 'cell-owner',
			formatter: ({firstName, lastName}) => {
				return `${firstName} ${lastName}`;
			},
		},
		{
			dataField: 'status',
			text: 'Status',
			classes: 'cell-progress',
			headerClasses: 'cell-progress',
			formatter: (value) => {
				return (
					<span className="badge bg-primary" role="button">{value}</span>
				);
			},
		},
		{
			dataField: 'updatedAt',
			text: 'Modified',
			classes: 'cell-modified',
			headerClasses: 'cell-modified',
			formatter: d => formatDateDMY(d),
		},
		{
			dataField: 'createdAt',
			text: 'Created',
			classes: 'cell-created',
			headerClasses: 'cell-created',
			formatter: d => formatDateDMY(d),
		},
	];
	
	/* Render HTML */
	
	return (
	<>
		<div id="apps" className="row table_v2 apps">
			<div className="col p-0">
				<div className="x_panel chatbot-builder">
					<div className="header-menu d-flex justify-content-between align-items-center">
						<div className="header-title d-flex align-items-center">
							<h1>APPS</h1>
						</div>
						<div className="header-actions d-flex align-items-center">
							<div className="action action-addnew">
								<button className="button button-blue" onClick={openModal}>
									+ Add New
								</button>
							</div>
						</div>
					</div>
					<div className="x_content">
						<div className="page-container d-flex flex-column">
							<div className="page-content">
								<DataTable
								dataKey       = "chatbots"
								tableHeading  = "Chatbots"
								navigateTo    = "/chatbot-builder"
								url           = "/chatbot"
								columns       = {tableColumns}
								refetch       = {refetch}
								onDelete      = {onDelete}
								onCopy        = {onCopy}
								onEdit        = {onEdit}
								onData        = {onData}
								onPreview     = {onPreview}
								isPreview     = {User.isAdmin()}
								defaultSorted = {[{ dataField: 'updatedAt', order: 'desc' }]}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Modal */}
			{isModalOpen && (
				<div className="modal app" onClick={closeModal}>
					<div className="modal-content" onClick={e=>e.stopPropagation()}>
						<div className="modal-header">
							<span className="modalclose" onClick={closeModal}>&times;</span>
							<h2>New app</h2>
						</div>
						<div className="modal-form">
							<Form
							usePUT        = {chatbotId ? true : false}
							url           = "/chatbot"
							initialValues = {data}
							onSuccess     = {onSuccess}
							>
								<div className="form-row col-full row-name">
									<Field
									as           = "input"
									id           = "name"
									name         = "name"
									placeholder  = "App name"
									autoComplete = "off"
									/>
								</div>
								<div className="form-row col-full row-actions">
									<button type="button" className="button button-large" onClick={closeModal}>Cancel</button>
									<button type="submit" className="button button-large button-blue">Create</button>
								</div>
							</Form>
						</div>
					</div>
				</div>
			)}
		</div>
		{
			/*
			{ User.isAdmin() && (
				<div className="row">
					<div className="col">
						<div className="x_panel">
							<div className="x_title">
								<h2>Chatbot Subimissions</h2>
								<div className="clearfix"></div>
							</div>
							<div className="x_content">
								<DataTable
								dataKey      = "chatbots"
								tableHeading = "Chatbots"
								navigateTo   = "/chatbot-review"
								url          = "/chatbot/submissions"
								columns      = {submissionsColumns}
								onDelete     = {() => {}}
								onEdit       = {onEdit}
								/>
							</div>
						</div>
					</div>
				</div>
			)}
			*/
		}
	</>
	);
};
